"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const countryCodesEU = [
    'AT',
    'BE',
    'BG',
    'CY',
    'CZ',
    'DK',
    'EE',
    'FI',
    'FR',
    'DE',
    'EL',
    'HR',
    'HU',
    'IE',
    'IT',
    'LV',
    'LT',
    'LU',
    'MT',
    'NL',
    'PL',
    'PT',
    'RO',
    'SK',
    'SI',
    'ES',
    'SE', // "Sweden"
];
/**
 *
 * @param countryCode ex: FR, ES, etc.
 */
const isFromEU = (countryCode) => countryCodesEU.includes(countryCode);
exports.default = isFromEU;
